import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';

// componentes
import { useSelector } from 'react-redux';
import { Card, Form, Button, Row, Col, OverlayTrigger, Popover, Tooltip, Badge, Alert } from 'react-bootstrap';
import { BrowserView, MobileView, isMobile, isBrowser } from "react-device-detect";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BotaoTabela from '../../../../Componentes/BotaoTabela';
import { converterReal } from '../../../../Funcoes';
import { faKey } from '@fortawesome/free-solid-svg-icons';

// componente
export default function Registro({
    dados,
    clicouEditar,
    clicouExcluir
}){

    // // estados
    // let configuracao = useSelector(state => state.ConfiguracaoReducer);
    // const configuracaoUsuarioReducer = useSelector(state => state.ConfiguracaoUsuarioReducer);

    // retorna opções
    let retornarOpcoes = () => {

        // retorna componentes
        return <>
            <BotaoTabela 
                onClick={clicouEditar}
                icone={["fas", "pencil-alt"]}
            >
                <span>Editar</span>
            </BotaoTabela>
            <BotaoTabela 
                onClick={clicouExcluir}
                icone={["fas", "trash"]}
            >
                <span>Excluir</span>
            </BotaoTabela>
        </>
    }

    return <> 

        {/* NAVEGADOR */}
        { isBrowser &&
            <tr
                style={{cursor: 'pointer'}}
                onClick={clicouEditar}
            >
                <td className={'estreito text-center'}>
                    <FontAwesomeIcon 
                        className={["icone"].join(' ')} 
                        style={{color: dados.dados.padrao === 'S' ? '#338dff' : '#4d4d4d'}} 
                        icon={faKey} 
                    />
                </td>
                <td>
                    <Badge variant={'info'} className={['rounded-pill mx-2 px-2'].join(' ')}>
                        {dados.totalEmpresas}
                    </Badge>
                    {dados.dados.nome}
                    {
                        dados.dados.chave &&
                        <small>({dados.dados.chave})</small>
                    }
                </td>
                <td className={'text-nowrap estreito text-right'}>
                    { retornarOpcoes() }
                </td>
            </tr>
        }

        {/* MOBILE */}
        {isMobile &&
            <Card
                className={'border-0 bg-light mb-2'}
                onClick={clicouEditar}
            >
                <Card.Body className={'p-2'}>
                    <div className={[isBrowser ? 'd-flex' : ''].join(' ')}>
                        <div className={'flex-grow-1'}>
                            <div>
                                <span>
                                    {dados.dados.nome}
                                </span>
                            </div>
                        </div>
                        <div className={'text-right'}>
                            { retornarOpcoes() }
                        </div>
                    </div>
                </Card.Body>
            </Card>
        }
    </>
}